import styled, { css } from 'styled-components';

export const Root = styled.div`
	flex: 1;
	background-color: ${({ theme }) => theme.black};
	width: 100%;
	position: relative;

	&::before {
		content: '';
		display: block;
		height: 0;
		padding-top: 56.25%;
	}

	${({ isPortal }) =>
		isPortal &&
		css`
			position: fixed;
			top: 0;
			left: 0;
			height: 100%;
			width: 100%;
			z-index: 9999;
		`}
`;

export const EmbedWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	border: 0;
`;
